// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"OxYET","CardContent":"_9M3F2","CardImage":"_3NAb_","CollectionGrid":"on5Wu"};